export const DEFAULT_API_ORIGIN = "https://apis.greenunison.com";
export const DEFAULT_SITE_URL = "https://blog.greenunison.com";

function trimTrailingSlash(value: string) {
  return value.replace(/\/+$/, "");
}

export function getApiOrigin() {
  const value =
    process.env.GATSBY_API_ORIGIN ||
    process.env.API_ORIGIN ||
    DEFAULT_API_ORIGIN;

  return trimTrailingSlash(value);
}

export function getSiteUrl() {
  const value =
    process.env.GATSBY_SITE_URL ||
    process.env.SITE_URL ||
    DEFAULT_SITE_URL;

  return trimTrailingSlash(value);
}

export function getApiTimeoutMs() {
  const parsed = Number(process.env.GATSBY_API_TIMEOUT_MS || 20000);

  return Number.isFinite(parsed) && parsed > 0 ? parsed : 20000;
}

export function getApiPageSize() {
  const parsed = Number(process.env.GATSBY_API_PAGE_SIZE || 50);

  return Number.isFinite(parsed) && parsed > 0 ? Math.min(Math.floor(parsed), 100) : 50;
}
